module.exports = __webpack_public_path__ + "static/media/icomoon.32bcf2e8.svg";